import React from 'react';

const CalendarTitleButton = ({ targetMode, testId, onSelectMode, children }) => (
  <button type="button" className="te-calendar-title" onClick={() => onSelectMode(targetMode)} data-testid={testId}>
    {children}
  </button>
);

export default CalendarTitleButton;
